<template>
  <section class="proposals-read">
    <navigation-tabs
      :tabs="tabs"
      class="proposals-read-tabs"
    >
      <template v-slot:information>
        <context-state :state="state">
          <template v-slot:loading>
            Carregando proposta...
          </template>

          <template v-slot:notfound>
            Proposta não encontrada :(
          </template>
        </context-state>

        <proposals-read-information v-if="proposal.id && Object.keys(attempts).length" />
      </template>

      <template v-slot:comments>
        <proposals-read-comments />
      </template>

      <template v-slot:log>
        <proposals-read-log
          v-if="proposal.id"
          :parent="'logProposals'"
        />
      </template>
    </navigation-tabs>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import PAGINATION from '@sdk/helpers/misc/pagination';

  import ContextState from '@cordel/components/Context/State.vue';

  import NavigationTabs from '@cordel/components/Navigation/Tabs.vue';

  import ProposalsReadActions from '@sdk/views/Proposals/Read/Actions.vue';
  import ProposalsReadInformation from '@sdk/views/Proposals/Read/Information.vue';
  import ProposalsReadLog from '@sdk/views/Proposals/Read/Log.vue';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import ProposalsReadComments from '@/views/Proposals/Read/Comments.vue';

  export default {
    name: 'ProposalsRead',
    components: {
      ContextState,

      NavigationTabs,

      ProposalsReadInformation,
      ProposalsReadComments,
      ProposalsReadLog,
    },
    data() {
      return {
        scroll: null,
        timeout: null,
        iterations: 0,

        nav: {
          action: ProposalsReadActions,
        },
      };
    },
    computed: {
      ...mapState([
        'customers',
        'proposals',
        'proposalAttempts',
      ]),

      state() {
        const {
          loading,
          item,
        } = this.proposals.read;

        if (loading) {
          return 'loading';
        }

        if (item.id) {
          return null;
        }

        return 'notfound';
      },

      proposal() {
        return this.proposals.read.item;
      },
      customer() {
        return this.customers.read.item;
      },

      attempts() {
        return this.proposalAttempts.list.items;
      },

      tabs() {
        const comments = this.proposal.comments_count;
        const activities = this.proposal.activities_count;

        return [{
          label: 'Informações',
          slot: 'information',
        }, {
          label: comments ? `Comentários (${comments})` : 'Comentários',
          slot: 'comments',
          initial: /comments/.test(this.$route.path),
        }, {
          label: activities ? `Log de atividades (${activities})` : 'Log de atividades',
          slot: 'log',
        }];
      },
    },
    mounted() {
      this.$store.dispatch('simulations/clear', { action: 'read' });
      this.$store.dispatch('customers/clear', { action: 'read' });
      this.$store.dispatch('proposals/clear', { action: 'read' });

      this.getProposal();
      this.getAttempts();
    },
    beforeDestroy() {
      this.iterations = -1;

      clearTimeout(this.timeout);
      clearTimeout(this.scroll);
    },
    methods: {
      getProposal() {
        return this.$store.dispatch('proposals/read', {
          id: this.$route.params.id,
        })
        .then(this.gotProposal);
      },
      gotProposal() {
        const rule = {
          store_id: this.proposals.read.item.store.id,
          vehicle_model_id: this.proposals.read.item.vehicle_model.id,
        };

        this.$store.dispatch('financingReturnRules/findForIntegratedBanks', rule);
        this.$store.dispatch('financingProductRules/findForIntegratedBanks', rule);

        return this.$store.dispatch('customers/read', {
          id: this.proposals.read.item.customer.id,
        });
      },

      getAttempts() {
        const {
          dispatch,
        } = this.$store;

        dispatch('proposalAttempts/filter', {
          CRUDL_append: !!this.timeout,
        });

        return dispatch('proposalAttempts/list', {
          proposal_id: this.$route.params.id,
          per_page: PAGINATION.MAX_PER_PAGE,
        }).then(this.gotAttempts);
      },
      gotAttempts() {
        switch (this.iterations) {
          case -1:
            return;
          case 0:
            this.scroll = setTimeout(this.showAttempt, 1000);
          default: // eslint-disable-line no-fallthrough
            this.iterations += 1;
        }

        clearTimeout(this.timeout);
        this.timeout = setTimeout(
          this.getAttempts,
          this.iterations > 5 ? 60000 : 5000,
        );
      },
      showAttempt() {
        if (/#attempt-/.test(this.$route.hash)) {
          const attempt = document.getElementById(this.$route.hash.replace('#', ''));

          if (attempt) {
            attempt.scrollIntoView({
              block: 'start',
              behavior: 'smooth',
            });
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-read {
  }

  .proposals-read-tabs {
    margin: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin: 0 var(--product--pwa--horizontal);
    }
  }
</style>
